import { isMobile } from "./isMobile";

/*
 * menu-trigger btn
 * ----------------------------------------------- */
jQuery(function ($) {
  var $menuTrigger = $(".menu-trigger");

  $.each($menuTrigger, function (i) {
    var $this = $(this);
    var id = $this.attr("data-bs-target");

    $(id).on("show.bs.collapse", function () {
      $("body").addClass("disable-scroll");
      $(".navbar-simple").addClass("is-collapse");
      $("footer").addClass("fixed-bottom");
    });

    $(id).on("hide.bs.collapse", function () {
      $("body").removeClass("disable-scroll");
      $(".navbar-simple").removeClass("is-collapse");
      $("footer").removeClass("fixed-bottom");
    });
  });

  $(".nav-link").on("click", function () {
    if (isMobile()) {
      $(".menu-trigger")[0].click();
    }
  });
});
